var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border border-avatar"},[_c('img',{staticClass:"avatar",attrs:{"src":require("../assets/assuro-blue-icon.svg")}})])
}]

export { render, staticRenderFns }